import { useAccountScheduledForDeletion } from "components/hooks/useAccountScheduledForDeletion";
import { useBoundStore } from "@/components/canvas/stores/useAppStore";

/** Returns true when editing should be blocked — either the model or the
 *  owning account is scheduled for deletion. */
export function useModelDeletionStatus(): boolean {
  const modelScheduledDeletionDate = useBoundStore(
    (state) => state.modelScheduledDeletionDate,
  );
  const isAccountScheduled = useAccountScheduledForDeletion();
  return (
    (modelScheduledDeletionDate !== null && modelScheduledDeletionDate > 0) ||
    isAccountScheduled
  );
}
